// extracted by mini-css-extract-plugin
export default {"description":"prepareAppointments_description__PZY32","subHeader":"prepareAppointments_subHeader__KLzHO"};